module.exports = __webpack_public_path__ + "static/media/2.06c07e2f.png";